export default __webpack_public_path__ + "static/media/haemodialysis.8566f606.svg";